import VectorProps from "./VectorProps";

export default function SalesSummaryIcon(props: VectorProps) {
  const { className = "", handleClick = () => null, height, width } = props;
  // from https://www.figma.com/file/LyX9wbSKd81UvXFeq58wMx/Foodsteps-Rebrand-Design-Library?type=design&node-id=1501-1661&mode=design&t=djPELc7GvHaLzkcp-0
  return (
    <svg
      className={className}
      fill="none"
      height={height ?? width}
      onClick={handleClick}
      width={width}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8 27.5216C22.218 27.5216 27.4208 22.3188 27.4208 15.9008C27.4208 9.48281 22.218 4.28 15.8 4.28C9.38201 4.28 4.1792 9.48281 4.1792 15.9008C4.1792 22.3188 9.38201 27.5216 15.8 27.5216Z"
        fill="#67DBC1"
      />
      <path
        d="M15.7998 21.56C12.7566 21.56 10.2798 19.0832 10.2798 16.04C10.2798 12.9968 12.7566 10.52 15.7998 10.52C18.843 10.52 21.3198 12.9968 21.3198 16.04C21.3198 19.0832 18.843 21.56 15.7998 21.56Z"
        fill="#DCFFD1"
      />
      <path
        d="M15.7999 11.4C18.3583 11.4 20.4399 13.4816 20.4399 16.04C20.4399 18.5984 18.3583 20.68 15.7999 20.68C13.2415 20.68 11.1599 18.5984 11.1599 16.04C11.1599 13.4816 13.2415 11.4 15.7999 11.4ZM15.7999 9.64001C12.2655 9.64001 9.3999 12.5056 9.3999 16.04C9.3999 19.5744 12.2655 22.44 15.7999 22.44C19.3343 22.44 22.1999 19.5744 22.1999 16.04C22.1999 12.5056 19.3343 9.64001 15.7999 9.64001Z"
        fill="black"
      />
      <path
        d="M8.48005 9.44C8.25445 9.44 8.02885 9.3536 7.85765 9.1824L2.89765 4.2224C2.55365 3.8784 2.55365 3.3216 2.89765 2.9776C3.24165 2.6336 3.79845 2.6336 4.14245 2.9776L9.10245 7.9376C9.44645 8.2816 9.44645 8.8384 9.10245 9.1824C8.93125 9.3536 8.70565 9.44 8.48005 9.44Z"
        fill="black"
      />
      <path
        d="M2.00012 8.14081C1.51372 8.14081 1.12012 7.74721 1.12012 7.26081V2.94081C1.12012 1.98081 1.90092 1.20001 2.86092 1.20001H7.18092C7.66732 1.20001 8.06092 1.59361 8.06092 2.08001C8.06092 2.56641 7.66732 2.96001 7.18092 2.96001H2.88012V7.26081C2.88012 7.74721 2.48652 8.14081 2.00012 8.14081Z"
        fill="black"
      />
      <path
        d="M3.52005 29.04C3.29445 29.04 3.06885 28.9536 2.89765 28.7824C2.55365 28.4384 2.55365 27.8816 2.89765 27.5376L7.89765 22.5376C8.24165 22.1936 8.79845 22.1936 9.14245 22.5376C9.48645 22.8816 9.48645 23.4384 9.14245 23.7824L4.14245 28.7824C3.97125 28.9536 3.74565 29.04 3.52005 29.04Z"
        fill="black"
      />
      <path
        d="M7.18092 30.56H2.86092C1.90092 30.56 1.12012 29.7792 1.12012 28.8192V24.4992C1.12012 24.0128 1.51372 23.6192 2.00012 23.6192C2.48652 23.6192 2.88012 24.0128 2.88012 24.4992V28.8H7.18092C7.66732 28.8 8.06092 29.1936 8.06092 29.68C8.06092 30.1664 7.66732 30.56 7.18092 30.56Z"
        fill="black"
      />
      <path
        d="M23.1599 9.72C22.9343 9.72 22.7087 9.6336 22.5375 9.4624C22.1935 9.1184 22.1935 8.5616 22.5375 8.2176L27.7775 2.9776C28.1215 2.6336 28.6783 2.6336 29.0223 2.9776C29.3663 3.3216 29.3663 3.8784 29.0223 4.2224L23.7823 9.4624C23.6111 9.6336 23.3855 9.72 23.1599 9.72Z"
        fill="black"
      />
      <path
        d="M29.9199 8.14081C29.4335 8.14081 29.0399 7.74721 29.0399 7.26081V2.96001H24.7391C24.2527 2.96001 23.8591 2.56641 23.8591 2.08001C23.8591 1.59361 24.2527 1.20001 24.7391 1.20001H29.0591C30.0191 1.20001 30.7999 1.98081 30.7999 2.94081V7.26081C30.7999 7.74721 30.4063 8.14081 29.9199 8.14081Z"
        fill="black"
      />
      <path
        d="M28.4001 29.04C28.1745 29.04 27.9489 28.9536 27.7777 28.7824L22.4177 23.4224C22.0737 23.0784 22.0737 22.5216 22.4177 22.1776C22.7617 21.8336 23.3185 21.8336 23.6625 22.1776L29.0225 27.5376C29.3665 27.8816 29.3665 28.4384 29.0225 28.7824C28.8513 28.9536 28.6257 29.04 28.4001 29.04Z"
        fill="black"
      />
      <path
        d="M29.0591 30.56H24.7391C24.2527 30.56 23.8591 30.1664 23.8591 29.68C23.8591 29.1936 24.2527 28.8 24.7391 28.8H29.0399V24.4992C29.0399 24.0128 29.4335 23.6192 29.9199 23.6192C30.4063 23.6192 30.7999 24.0128 30.7999 24.4992V28.8192C30.7999 29.7792 30.0191 30.56 29.0591 30.56Z"
        fill="black"
      />
    </svg>
  );
}
